import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'MathXPlusYIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-math-x-plus-y",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M16 9l3 5.063"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M2 9l6 6"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M2 15l6 -6"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M22 9l-4.8 9"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M10 12h4"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 10v4"
    }, null), _createTextVNode(" ")]);
  }
};